const getURLParam = (parameterName) => {
  let queriedParameterValue = null;

  if (window.location.search !== '') {
    const params = (new URL(document.location)).searchParams;
    queriedParameterValue = params.get(parameterName);
  }
  return queriedParameterValue;
};

// removeURLParam and insertURLParam were taken from https://stackoverflow.com/a/48889338 and adjusted
function removeURLParam(url, parameter) {
  const urlparts = url.split('?');
  if (urlparts.length >= 2) {
    const prefix = `${encodeURIComponent(parameter)}=`;
    const pars = urlparts[1].split(/[&;]/g);

    for (let i = pars.length - 1; i > -1; i -= 1) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        pars.splice(i, 1);
      }
    }

    url = urlparts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
    return url;
  }
  return url;
}

function removeAllURLParams() {
  if (window.history.pushState) {
    let currentUrlWithOutHash =
        window.location.origin + window.location.pathname + window.location.search;
    const urlParts = currentUrlWithOutHash.split('?');
    if (urlParts.length >= 2) {
      const pars = urlParts[1].split(/[&;]/g);

      for (let i = pars.length - 1; i > -1; i -= 1) {
        pars.splice(i, 1);
      }

      currentUrlWithOutHash = urlParts[0] + (pars.length > 0 ? `?${pars.join('&')}` : '');
      window.history.pushState({ path: currentUrlWithOutHash }, '', currentUrlWithOutHash);
    }
  }
}

function setURLParam(key, value, url = null) {
  if (window.history.pushState) {
    let currentUrlWithOutHash;
    let hash = '';
    if (url !== null) {
      [currentUrlWithOutHash, hash] = [...url.split('#'), ''];
    } else {
      currentUrlWithOutHash =
          window.location.origin + window.location.pathname + window.location.search;
      hash = window.location.hash;
    }
    currentUrlWithOutHash = removeURLParam(currentUrlWithOutHash, key);

    let queryStart;
    if (currentUrlWithOutHash.indexOf('?') !== -1) {
      queryStart = '&';
    } else {
      queryStart = '?';
    }

    const newurl = `${currentUrlWithOutHash + queryStart + key}=${value}${hash}`;
    if (url === null) {
      window.history.pushState({ path: newurl }, '', newurl);
    }
    return newurl;
  }
  return '';
}
export {
  getURLParam, setURLParam, removeURLParam, removeAllURLParams,
};
